import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IApplication } from "../../shared/model/application.model";
import { ILocality } from "../../shared/model/locality.model";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Row } from "reactstrap";
import { getProvincesNotDuplicated } from "../../shared/helpers/getProvincesNotDuplicated";

interface IProps {
  application: IApplication;
}
export const ApplicationCardList = (props: IProps) => {
  const { application } = props;
  const history = useHistory();
  const location = useLocation();
  return (
    <div
      className="application-card"
      onClick={(e) => {
        e.preventDefault();
        history.push(`/${application.id}/${location.search}`);
      }}
    >
      <Row className="ms-3 me-3">
        <div className="title-card-list">{application.name}</div>
      </Row>
      <Row className="ms-3 me-3 description-card-list">
        <p>
          {application.description?.substring(0, 500)}
          {application?.description &&
            application.description.length > 500 &&
            "..."}
        </p>
      </Row>
      <Row>
        <div className="provinces-card-list">
          {application?.localities && getProvincesNotDuplicated(application?.localities).map((locality: ILocality, index: number) => (
            <div
              className="application-extended-detail-footer-locations"
              key={index}
            >
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="icon-province"
              />
              <span>{locality?.province?.name}</span>
            </div>
          ))}
        </div>
      </Row>
    </div>
  );
};
